import { H3 } from '@repo/ui/components/Typography';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

export const Title = styled(H3)`
  font-size: 150px;
  line-height: 1;
  font-weight: 500;
`;

export const Subtitle = styled(H3)`
  font-size: ${themeStyle.fontSize36};
  line-height: 1.5;
`;

export const Divider = styled.div`
  height: 275px;
  border-right: 1px solid ${themeStyle.varInkLight};

  html[data-theme='dark'] &&,
  .dark && {
    border-right: 1px solid ${themeStyle.varInkSuperLight};
  }
`;
